import React, { useEffect, useState } from "react";
import api, { imageUrl } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Switch } from "../../components/ui/switch";
import { Plus, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";
import { ImageUpload } from "../../components/ImageUpload";

const EMPTY = { key: "", name: "", subtitle: "", order: 0, image: "", active: true };

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);

  const load = () => api.get("/admin/categories").then((r) => setCats(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.key || !form.name) { toast.error("Key and name required"); return; }
    const payload = { ...form, order: Number(form.order || 0) };
    try {
      if (editId) await api.put(`/admin/categories/${editId}`, payload);
      else await api.post("/admin/categories", payload);
      toast.success("Category saved"); setOpen(false); load();
    } catch (e) { toast.error("Error"); }
  };
  const del = async (id) => { await api.delete(`/admin/categories/${id}`); toast.success("Deleted"); load(); };

  return (
    <div data-testid="admin-categories">
      <div className="flex justify-between items-center mb-6">
        <h1 className="font-serif text-3xl text-navy">Categories</h1>
        <button onClick={() => { setForm(EMPTY); setEditId(null); setOpen(true); }} data-testid="new-category-btn" className="flex items-center gap-2 bg-navy text-cream text-sm font-semibold px-4 py-2.5 rounded-full hover:bg-navy-soft"><Plus size={15} /> Add Category</button>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c) => (
          <div key={c.id} className="bg-white rounded-xl border border-black/5 overflow-hidden" data-testid={`admin-category-${c.key}`}>
            <img src={imageUrl(c.image)} alt={c.name} className="w-full h-28 object-cover" />
            <div className="p-4">
              <div className="flex justify-between items-start">
                <div><div className="font-serif text-lg text-navy">{c.name}</div><div className="text-xs text-muted-foreground">{c.subtitle}</div></div>
                <div className="flex gap-2"><button onClick={() => { setForm(c); setEditId(c.id); setOpen(true); }} className="text-muted-foreground hover:text-navy"><Pencil size={15} /></button><button onClick={() => del(c.id)} className="text-muted-foreground hover:text-destructive"><Trash2 size={15} /></button></div>
              </div>
              <div className="flex items-center justify-between mt-3"><span className="text-xs text-muted-foreground">Order: {c.order}</span><span className={`text-xs px-2 py-0.5 rounded-full ${c.active ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>{c.active ? "Active" : "Hidden"}</span></div>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle className="font-serif text-2xl">{editId ? "Edit" : "New"} Category</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <input placeholder="Key (e.g. biryani)" value={form.key} onChange={(e) => setForm({ ...form, key: e.target.value.toLowerCase() })} data-testid="cat-key-input" className="w-full border border-black/15 rounded-lg px-3 py-2 text-sm" />
            <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="cat-name-input" className="w-full border border-black/15 rounded-lg px-3 py-2 text-sm" />
            <input placeholder="Subtitle" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} className="w-full border border-black/15 rounded-lg px-3 py-2 text-sm" />
            <ImageUpload label="Category Image" value={form.image} onChange={(v) => setForm({ ...form, image: v })} testId="category-image" />
            <input type="number" placeholder="Display order" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} className="w-full border border-black/15 rounded-lg px-3 py-2 text-sm" />
            <label className="flex items-center gap-2 text-sm"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} /> Active</label>
            <button onClick={save} data-testid="save-category-btn" className="w-full bg-navy text-cream font-semibold py-3 rounded-full hover:bg-navy-soft">Save Category</button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
